export const api = {
    users: {
        all: '/users/',
        login: '/users/login',
        confirmEmail: '/users/confirm-email/{code}/{email}',
        settings: '/users/settings',
        changeEmail: '/users/change-email',
        changePassword: '/users/change-password',
        membership: '/users/membership',
        wallet: '/users/wallet'
    },
    information: {
        single: '/information/{labelId}',
        user: '/information/',
        categoryInformation: '/information/category/{categoryName}'
    },
    categories: {
        all: '/categories/',
        single: '/categories/{categoryId}'
    },
    cards: {
        user: '/cards/',
        card: '/cards/{cardId}/',
        allCards: '/cards/{cardId}/{all}',
        public: '/cards/{cardId}/public',
        privacy: '/cards/{cardId}/privacy',
        info: '/cards/{cardId}/info',
        default: '/cards/{cardId}/default',
        image: '/cards/{cardId}/image',
        name: '/cards/{cardId}/name',
        shareLink: '/cards/{cardId}/shareLink',
    },
    connections: {
        user: '/connections/',
        userCard: '/connections/user-card/{cardId}',
        card: '/connections/card/{cardId}',
        label: '/connections/card/{cardId}/label',
        default: '/connections/card/{cardId}/default',
        alias: '/connections/card/{cardId}/alias',
        unsync: '/connections/card/{cardId}/unsync',
        requests: '/connections/requests/',
        acceptRequest: '/connections/requests/{requestId}/accept/',
        denyRequest: '/connections/requests/{requestId}/reject/',
        follow: '/connections/follow',
        unfollow: '/connections/unfollow/{cardId}',
        favorite: '/connections/favorite/{cardId}',
        tags: '/connections/tags',
        connectionTags: '/connections/card/{cardId}/tags',
        filters: '/connections/filters',
        cancelRequest: '/connections/requests/card/{cardId}'
    },
    general: {
        categories: '/general/categories/',
        userSections: '/general/sections/category/{categoryName}/user/{userId}'
    },
    sections: {
        all: '/sections/',
        single: '/sections/{sectionId}',
        rename: '/sections/{sectionId}/rename',
        renameTitle: '/sections/{sectionId}/renameTitle',
        clone: '/sections/{sectionId}/clone',
        deleteAll: '/sections/deleteAll/{categoryName}',
    },
    informationList: {
        single: '/information_list/{infoType}/{countryId}/{stateId}',
        address: '/information_list/address/info/{infoId}',
        all: '/information_list/all'
    },
    languages: {
        all: '/languages/',
        single: '/languages/user/{userId}/language/{lang}',
        user: '/languages/user/{userId}'
    },
    images: {
        user: '/images/user/{userId}',
        single: '/images/user/{userId}/image/{imgId}',
        checkImages: '/images/user/{userId}/checkImages'
    },
    userLabels: {
        user: '/user-labels/'
    },
    availability: {
        all: '/availability/',
        single: '/availability/{id}'
    },
    notifications: {
        all: '/notifications/'
    },
    tags: {
        all: '/tags',
        single: '/tags/{tagId}'
    },
    search: {
        all: '/search'
    },
    forgotPassword: {
        all: '/forgot-my-password',
        single: '/forgot-my-password/{requestId}'
    }
}